import { render, staticRenderFns } from "./addPurchaseOrder.vue?vue&type=template&id=05b64711&scoped=true"
import script from "./addPurchaseOrder.vue?vue&type=script&lang=js"
export * from "./addPurchaseOrder.vue?vue&type=script&lang=js"
import style0 from "./addPurchaseOrder.vue?vue&type=style&index=0&id=05b64711&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b64711",
  null
  
)

export default component.exports